import { computed } from 'vue'
import useFormatters from '@/composables/useFormatters'

export default function usePedidoHelpers() {
  const { formatDate } = useFormatters()

  /**
   * Personalizar a descrição do status do pedido
   */
  const getStatusDescription = (pedido) => {
    let status = ''
    let icon = ''
    let iconColor = ''

    if (pedido.status === '4') {
      status = `Pedido não aceito - ${formatDate(pedido.dtcancel)} Obs: ${pedido.motivocancel || ''}`
      icon = 'mdi-close-circle'
      iconColor = 'error'
    } else if (pedido.status === '5' && pedido.dtcancel != null) {
      status = `Cancelado pelo cliente - ${formatDate(pedido.dtcancel)} Obs: ${pedido.motivocancel || ''}`
      icon = 'mdi-account-cancel'
      iconColor = 'error'
    } else if (pedido.dtentrega && pedido.dtentrega != null) {
      status = `Entregue - ${formatDate(pedido.dtentrega)}`
      icon = 'mdi-package-variant-closed-check'
      iconColor = 'success'
    } else if (pedido.status == 2 && pedido.dtsaida && pedido.dtsaida != null) {
      status = `Saiu para entrega - ${formatDate(pedido.dtsaida)}`
      icon = 'mdi-truck-delivery'
      iconColor = 'info'
    } else if (pedido.dtaceite && pedido.dtaceite != null) {
      status = `Preparando para entrega - ${formatDate(pedido.dtaceite)}`
      icon = 'mdi-check-circle'
      iconColor = 'success'
    } else {
      status = 'Aguardando aceite'
      icon = 'mdi-clock-outline'
      iconColor = 'warning'
    }

    return { text: status, icon, iconColor }
  }

  /**
   * Definir cor de background do card
   */
  const getCardBackgroudColor = (pedido) => {
    if (pedido.pendente === 1) {
      return 'background-color: #ff9780'
    } else if (
      pedido?.nao_resolvido ||
      (pedido.status == 4 && pedido.motivocancel === 'Revendedor nao aceitou o pedido a tempo.')
    ) {
      return 'background-color: #FF00FF'
    } else if (pedido.area_externa === true) {
      return 'background-color: #FFFFCC'
    } else if (pedido?.produto?.tipoproduto?.categoria === 'AGUA') {
      return 'background-color: rgba(25, 118, 210, 0.15)'
    }
    return ''
  }

  /**
   * Criar um objeto com informações para exibir no card
   */
  const cardDisplayInfo = (pedido) => {
    const memoizedStatus = computed(() => getStatusDescription(pedido))
    const memoizedBackground = computed(() => getCardBackgroudColor(pedido))

    return {
      statusDescription: memoizedStatus,
      backgroundColor: memoizedBackground,
    }
  }

  const isNullOrEmpty = (value) => {
    return value === null || value === undefined || value === ''
  }

  /**
   * Descrição personalizada para pedidos suspeitos
   */
  const getSuspeitoDescricao = (suspeitoValue) => {
    const suspeito = Number(suspeitoValue)
    switch (suspeito) {
      case 1:
      case 2:
        return 'Pedido Suspeito'
      case 3:
        return 'Suspeito Avaliação'
      case 4:
        return 'Suspeito Mudança de Horário'
      case 5:
        return 'Suspeito Tempo Pedido Estourado'
      default:
        return ''
    }
  }

  return {
    getStatusDescription,
    getCardBackgroudColor,
    cardDisplayInfo,
    isNullOrEmpty,
    getSuspeitoDescricao,
  }
}
